import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { useEffect, useState } from "react";
import createClient from '../Client';
import avatar from '../images/avatar.png';


const TestimonialContents = () => {
  const [reviewData, setReviewData] = useState([]);

  useEffect(() => {
    createClient.fetch(`*[_type=="testimonials" && !(_id in path('drafts.**'))] | order(_createdAt desc){
            ...,
            "ThumbImage": testimonials_user_image.asset->url,
            "desc":testimonials_description,
            "modelImage": testimonials_carousel_image.asset->url
          }`).then((data) => {
      setReviewData(data);

    })
      .catch(console.error);
  }, [])

  return (
    <>
      <div className="row">
        <div className="col-12">
          {reviewData.length > 0 && (

            <Carousel
              showArrows={false}
              showStatus={false}
              showIndicators={false}
              showThumbs={true}
              autoPlay={true}
              infiniteLoop={true}
              emulateTouch={true}
            >
              {reviewData.slice(0, 6).map((testimonial, index) => (
                <div key={index} className="testimonial-slide">
                  <img className='main-image' src={testimonial.ThumbImage} />
                  <div className='testimonial-panel'>
                    <div className='row testimonial-wrapper'>
                      <div className="col-12 col-lg-6 desc_wrapper">
                        <div className="testimonial-body">
                          <h4 className="testimonial-name">{testimonial.testimonials_name}</h4>
                          <p className="testimonial-title">{testimonial.testimonials_company_name}</p>
                          <div className="rating">
                            {Array.from(new Array(5)).map((_, index) => (
                              <i key={index} className={`fas fa-star  ${index < testimonial.rating ? 'active' : ''}`}></i>
                            ))}
                          </div>
                          <p className="testimonial-desc">{testimonial.desc}</p>
                        </div>
                      </div>
                      <div className="col-12 col-lg-6 img_wrapper">
                        <div className="testimonial-img">
                          <img src={testimonial.modelImage ? testimonial.modelImage : avatar} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          )}
        </div>
      </div>
    </>
  );
}

export default TestimonialContents;